import React from 'react'
import DownloadIcon from '@material-ui/icons/GetAppRounded'
import MailOutlineRoundedIcon from '@material-ui/icons/MailOutlineRounded'
import ToolTip from '../../UI/ToolTip'
import { TwoLineItem, LeftSideColor, SingleItemBold } from '../../UI/TableItem'
import moment from 'moment'
import styled from '@emotion/styled'

const StyledTr = styled.tr`
  border-left: ${({ color }) => `5px solid ${color}`};
`

const ReportItem = ({ report, history, index }) => {
  const color = LeftSideColor(index)

  return (
    <StyledTr
      className="tableRowHover"
      key={index}
      onClick={() => history.push(`/app/reports/${report._id}`)}
      color={color.color}
    >
      <TwoLineItem text={report.name} subText={report.description} width="20" />

      <SingleItemBold text={moment(report.createdDt).format('MMM DD YYYY')} width="15" />
      <SingleItemBold text={report.createdBy} width="15" />
      <SingleItemBold text={report.systemNotes} width="15" />

      <td style={{ textAlign: 'right', width: '10%' }}>
        <ToolTip title="E-mail">
          <MailOutlineRoundedIcon
            className="actionsIcon"
            // onClick={() => undefined)}
          />
        </ToolTip>
        <ToolTip title="Download">
          <DownloadIcon
            className="actionsIcon"
            // onClick={() => undefined}
          />
        </ToolTip>
      </td>
    </StyledTr>
  )
}

export default ReportItem
